"use client";

import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile(breakpoint?: number) {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined
  );

  React.useEffect(() => {
    const effectiveBreakpoint = breakpoint ?? MOBILE_BREAKPOINT;
    const mql = window.matchMedia(`(max-width: ${effectiveBreakpoint - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < effectiveBreakpoint);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < effectiveBreakpoint);
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint]);

  return !!isMobile;
}
